const $b11092b003750ebb$export$9f048bf86ee2e9d2 = [
    {
        number: 1,
        pos: [
            47,
            71
        ]
    },
    {
        number: 2,
        pos: [
            56,
            56
        ]
    },
    {
        number: 3,
        pos: [
            64,
            43
        ]
    },
    {
        number: 4,
        pos: [
            63,
            26
        ]
    },
    {
        number: 5,
        pos: [
            61,
            16
        ]
    },
    {
        number: 6,
        pos: [
            53,
            7.5
        ]
    },
    {
        number: 7,
        pos: [
            45,
            2
        ]
    },
    {
        number: 8,
        pos: [
            44,
            25
        ]
    },
    {
        number: 9,
        pos: [
            45,
            45
        ]
    },
    {
        number: 10,
        pos: [
            41.5,
            52.5
        ]
    },
    {
        number: 11,
        pos: [
            34,
            70
        ]
    },
    {
        number: 12,
        pos: [
            45,
            93
        ]
    }
];


let $25be8ad6e28b139f$var$circle, $25be8ad6e28b139f$var$radius, $25be8ad6e28b139f$var$circumference;
function $25be8ad6e28b139f$export$2cd8252107eb640b(id) {
    $25be8ad6e28b139f$var$circle = document.querySelector(`#${id}>circle`);
    $25be8ad6e28b139f$var$radius = $25be8ad6e28b139f$var$circle.r.baseVal.value;
    $25be8ad6e28b139f$var$circumference = $25be8ad6e28b139f$var$radius * 2 * Math.PI;
    $25be8ad6e28b139f$var$circle.style.strokeDasharray = `${$25be8ad6e28b139f$var$circumference} ${$25be8ad6e28b139f$var$circumference}`;
    $25be8ad6e28b139f$var$circle.style.strokeDashoffset = `${$25be8ad6e28b139f$var$circumference}`;
}
function $25be8ad6e28b139f$export$e352b740a6841494(fraction) {
    const offset = $25be8ad6e28b139f$var$circumference - fraction * $25be8ad6e28b139f$var$circumference;
    $25be8ad6e28b139f$var$circle.style.strokeDashoffset = offset;
}


function $fe8af8a42c4a74bc$export$f10f97528f780cc6(element) {
    element.setAttribute('open', '');
}
function $fe8af8a42c4a74bc$export$9c35fb790e61b3f6(element) {
    if (element.hasAttribute('open')) $fe8af8a42c4a74bc$export$ff74030248f7f2bd(element);
    else $fe8af8a42c4a74bc$export$f10f97528f780cc6(element);
}
function $fe8af8a42c4a74bc$export$ff74030248f7f2bd(element) {
    element.removeAttribute('open');
}


const $aa34d0705ed36eb6$export$e0b46b07fd1bee3a = {
    // Menu slide-in
    'menu-btn-open': {
        type: 'aria-label',
        fr: 'Ouvrir le menu',
        en: 'Open menu',
        de: "Men\xfc \xf6ffnen",
        it: 'Apri menu'
    },
    'menu-btn-close': {
        type: 'aria-label',
        fr: 'Fermer le menu',
        en: 'Close menu',
        de: "Men\xfc schlie\xdfen",
        it: 'Chiudi menu'
    },
    'menu-nav-btn-text-audioguide': {
        type: 'aria-label',
        fr: "Retour \xe0 l'audioguide",
        en: 'Back to the audioguide',
        de: "Zur\xfcck zum Audioguide",
        it: 'Torna all\'audioguida'
    },
    'menu-nav-btn-text-audioguide': {
        fr: "Retour \xe0 l'audioguide",
        en: 'Back to the audioguide',
        de: "Zur\xfcck zum Audioguide",
        it: 'Torna all\'audioguida'
    },
    'menu-nav-btn-about': {
        type: 'aria-label',
        fr: "\xc0 propos",
        en: 'About',
        de: "\xdcber",
        it: 'Informazioni'
    },
    'menu-nav-btn-text-about': {
        fr: "\xc0 propos",
        en: 'About',
        de: "\xdcber",
        it: 'Informazioni'
    },
    'menu-nav-btn-credits': {
        type: 'aria-label',
        fr: "Cr\xe9dits",
        en: 'Credits',
        de: 'Credits',
        it: 'Crediti'
    },
    'menu-nav-btn-text-credits': {
        fr: "Cr\xe9dits",
        en: 'Credits',
        de: 'Credits',
        it: 'Crediti'
    },
    'menu-language-select-title': {
        fr: 'Choix de la langue',
        en: 'Language selection',
        de: 'Sprachauswahl',
        it: 'Selezione della lingua'
    },
    // Audioguide page
    'audioguide-title': {
        fr: 'Audioguide',
        en: 'Audioguide',
        de: 'Audioguide',
        it: 'Audioguida'
    },
    'audioguide-transcription-title': {
        fr: 'Transcription',
        en: 'Transcription',
        de: 'Transkription',
        it: 'Trascrizione'
    },
    'transcription-btn-toggle': {
        type: 'aria-label',
        fr: 'Afficher la transcription',
        en: 'Show transcription',
        de: 'Transkription anzeigen',
        it: 'Mostra trascrizione'
    },
    'audioguide-player-loading-text': {
        // Also used for player title
        fr: 'Chargement...',
        en: 'Loading...',
        de: 'Laden...',
        it: 'Caricamento...'
    },
    'play-controls': {
        type: 'aria-label',
        fr: "Contr\xf4les de lecture",
        en: 'Audio playback controls',
        de: 'Wiedergabesteuerung',
        it: 'Controlli di riproduzione'
    },
    'seekForward': {
        type: 'aria-label',
        fr: 'Avancer de 5 secondes',
        en: 'Seek forward 5 seconds',
        de: "5 Sekunden vorw\xe4rts springen",
        it: 'Avanza di 5 secondi'
    },
    'seekBackward': {
        type: 'aria-label',
        fr: 'Reculer de 5 secondes',
        en: 'Seek backward 5 seconds',
        de: "5 Sekunden zur\xfcckspringen",
        it: 'Riavvolgi di 5 secondi'
    },
    'play-pause': {
        type: 'aria-label',
        fr: 'Lecture/Pause',
        en: 'Play/Pause',
        de: 'Wiedergabe/Pause',
        it: 'Riproduci/Pausa'
    },
    // About page
    'about-title': {
        fr: "\xc0 propos",
        en: 'About',
        de: "\xdcber",
        it: 'Informazioni'
    },
    // Credits page
    'credits-title': {
        fr: "Cr\xe9dits",
        en: 'Credits',
        de: 'Credits',
        it: 'Crediti'
    }
};


let $ad8ee3d37bdec1f0$var$lang = 'fr'; // Default language
const $ad8ee3d37bdec1f0$var$supportedLanguages = [
    'fr',
    'en',
    'de',
    'it'
];
function $ad8ee3d37bdec1f0$export$2cd8252107eb640b() {
    // Detect language
    $ad8ee3d37bdec1f0$var$lang = (navigator.language || navigator.userLanguage).slice(0, 2);
    if (!$ad8ee3d37bdec1f0$var$supportedLanguages.includes($ad8ee3d37bdec1f0$var$lang)) $ad8ee3d37bdec1f0$var$lang = 'en';
    $ad8ee3d37bdec1f0$var$translateAllLocalizedStrings();
}
function $ad8ee3d37bdec1f0$export$dec8f99c0c14e178() {
    return $ad8ee3d37bdec1f0$var$lang;
}
function $ad8ee3d37bdec1f0$export$a3665b844fbc095d(newLang) {
    if ($ad8ee3d37bdec1f0$var$supportedLanguages.includes(newLang)) {
        $ad8ee3d37bdec1f0$var$lang = newLang;
        document.documentElement.setAttribute('lang', newLang);
        window.dispatchEvent(new Event('languagechange'));
        $ad8ee3d37bdec1f0$var$translateAllLocalizedStrings();
        // Update aria-activedescendant for #language-select
        const languageSelect = document.getElementById('language-select');
        languageSelect.setAttribute('aria-activedescendant', `language-select-link-${newLang}`);
    } else console.error(`Unsupported language: ${newLang}`);
}
function $ad8ee3d37bdec1f0$var$translateAllLocalizedStrings() {
    for (const [id, string] of Object.entries((0, $aa34d0705ed36eb6$export$e0b46b07fd1bee3a))){
        const element = document.getElementById(id);
        if (!element) {
            console.error(`Element with id ${id} not found`);
            continue;
        }
        if (string[$ad8ee3d37bdec1f0$var$lang] === undefined) {
            console.error(`Missing translation for ${id} in ${$ad8ee3d37bdec1f0$var$lang}`);
            continue;
        }
        switch(string.type){
            case 'aria-label':
                element.setAttribute('aria-label', string[$ad8ee3d37bdec1f0$var$lang]);
                break;
            case undefined:
                // Default case for strings without a type
                element.textContent = string[$ad8ee3d37bdec1f0$var$lang];
                break;
            default:
                console.error(`Unknown type for localized string: ${string.type}`);
        }
    }
}
function $ad8ee3d37bdec1f0$export$4e490aaac5c28cc3(id) {
    const string = (0, $aa34d0705ed36eb6$export$e0b46b07fd1bee3a)[id];
    if (string === undefined) {
        console.error(`Missing localized string: ${id}`);
        return id;
    }
    if (string[$ad8ee3d37bdec1f0$var$lang] === undefined) {
        console.error(`Missing translation for ${id} in ${$ad8ee3d37bdec1f0$var$lang}`);
        return id;
    }
    return string[$ad8ee3d37bdec1f0$var$lang];
}




let $0005258c7ec188e8$var$menuElement;
let $0005258c7ec188e8$var$menuCloseButtonElement;
let $0005258c7ec188e8$var$menuLinkElements;
let $0005258c7ec188e8$var$languageSelectLinks;
function $0005258c7ec188e8$export$2cd8252107eb640b() {
    $0005258c7ec188e8$var$menuElement = document.getElementById('menu');
    $0005258c7ec188e8$var$menuCloseButtonElement = document.getElementById('menu-btn-close');
    $0005258c7ec188e8$var$menuLinkElements = document.querySelectorAll('.menu-link');
    $0005258c7ec188e8$var$languageSelectLinks = document.querySelectorAll('.language-select-link');
    // Add event listeners for menu buttons
    const menuButtonElement = document.getElementById('menu-btn-open');
    menuButtonElement.addEventListener('click', ()=>(0, $fe8af8a42c4a74bc$export$f10f97528f780cc6)($0005258c7ec188e8$var$menuElement));
    $0005258c7ec188e8$var$menuCloseButtonElement.addEventListener('click', ()=>{
        (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)($0005258c7ec188e8$var$menuElement);
    });
    $0005258c7ec188e8$var$menuLinkElements.forEach((element)=>{
        element.addEventListener('click', (event)=>{
            event.preventDefault();
            (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)($0005258c7ec188e8$var$menuElement);
            // Close all pages
            const pages = document.querySelectorAll('.page');
            pages.forEach((page)=>{
                (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)(page);
            });
            // Close the transcription panel if open
            const transcriptionPanel = document.getElementById('transcription-panel');
            (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)(transcriptionPanel);
            // Open the target element
            const target = element.getAttribute('data-page');
            (0, $fe8af8a42c4a74bc$export$f10f97528f780cc6)(document.getElementById(target));
            // Update the aria-expanded attributes on links
            $0005258c7ec188e8$var$menuLinkElements.forEach((link)=>{
                link.setAttribute('aria-expanded', 'false');
            });
            element.setAttribute('aria-expanded', 'true');
        });
    });
    // Add event listeners for language selection
    $0005258c7ec188e8$var$languageSelectLinks.forEach((element)=>{
        element.addEventListener('click', (event)=>{
            event.preventDefault();
            const newLang = element.getAttribute('lang');
            if (newLang !== (0, $ad8ee3d37bdec1f0$export$dec8f99c0c14e178)()) (0, $ad8ee3d37bdec1f0$export$a3665b844fbc095d)(newLang);
            (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)($0005258c7ec188e8$var$menuElement);
        });
    });
    // Set the active language link based on the current language
    window.addEventListener('languagechange', ()=>{
        const newLang = (0, $ad8ee3d37bdec1f0$export$dec8f99c0c14e178)();
        // Update the current language link
        $0005258c7ec188e8$var$languageSelectLinks.forEach((element)=>{
            const lang = element.getAttribute('lang');
            if (lang === newLang) {
                element.classList.add('current');
                element.setAttribute('aria-selected', 'true');
            } else {
                element.classList.remove('current');
                element.removeAttribute('aria-selected');
            }
        });
    });
}


let $d706c914d748cb55$var$player;
let $d706c914d748cb55$var$audioElement;
let $d706c914d748cb55$var$playControls, $d706c914d748cb55$var$loading;
let $d706c914d748cb55$var$seekBackwardBtn, $d706c914d748cb55$var$seekForwardBtn, $d706c914d748cb55$var$playPauseBtn, $d706c914d748cb55$var$playIcon, $d706c914d748cb55$var$pauseIcon;
let $d706c914d748cb55$var$playing = false;
let $d706c914d748cb55$var$currentPoint = null;
function $d706c914d748cb55$var$init() {
    $ad8ee3d37bdec1f0$export$2cd8252107eb640b();
    $0005258c7ec188e8$export$2cd8252107eb640b();
    // Get elements
    $d706c914d748cb55$var$player = document.getElementById('player');
    $d706c914d748cb55$var$playControls = document.getElementById('play-controls');
    $d706c914d748cb55$var$loading = document.getElementById('audioguide-player-loading-text');
    $d706c914d748cb55$var$seekBackwardBtn = document.getElementById('seekBackward');
    $d706c914d748cb55$var$seekForwardBtn = document.getElementById('seekForward');
    $d706c914d748cb55$var$playPauseBtn = document.getElementById('play-pause');
    $d706c914d748cb55$var$playIcon = document.getElementById('play-icon');
    $d706c914d748cb55$var$pauseIcon = document.getElementById('pause-icon');
    $d706c914d748cb55$var$audioElement = document.querySelector('audio');
    // Add event listeners for transcription button
    const transcriptionButtonElement = document.getElementById('transcription-btn-toggle');
    const transcriptionPanel = document.getElementById('transcription-panel');
    transcriptionButtonElement.addEventListener('click', (event)=>{
        event.preventDefault();
        (0, $fe8af8a42c4a74bc$export$9c35fb790e61b3f6)(transcriptionPanel);
    });
    // Add event listeners for player buttons
    $d706c914d748cb55$var$seekBackwardBtn.addEventListener('click', ()=>{
        $d706c914d748cb55$var$audioElement.currentTime -= 5;
        $d706c914d748cb55$var$updateProgress();
    });
    $d706c914d748cb55$var$seekForwardBtn.addEventListener('click', ()=>{
        $d706c914d748cb55$var$audioElement.currentTime += 5;
        $d706c914d748cb55$var$updateProgress();
    });
    $d706c914d748cb55$var$playPauseBtn.addEventListener('click', ()=>{
        if ($d706c914d748cb55$var$playing) $d706c914d748cb55$var$audioElement.pause();
        else $d706c914d748cb55$var$audioElement.play();
    });
    // Periodically update the progress indicator
    setInterval(()=>{
        if ($d706c914d748cb55$var$playing) $d706c914d748cb55$var$updateProgress();
    }, 1000);
    // Handle play event
    $d706c914d748cb55$var$audioElement.addEventListener('play', (event)=>{
        $d706c914d748cb55$var$playing = true;
        $d706c914d748cb55$var$playIcon.classList.add('hidden');
        $d706c914d748cb55$var$pauseIcon.classList.remove('hidden');
        $d706c914d748cb55$var$updateProgress();
    });
    // Handle pause event
    $d706c914d748cb55$var$audioElement.addEventListener('pause', (event)=>{
        $d706c914d748cb55$var$playing = false;
        $d706c914d748cb55$var$playIcon.classList.remove('hidden');
        $d706c914d748cb55$var$pauseIcon.classList.add('hidden');
        $d706c914d748cb55$var$updateProgress();
    });
    // Reset play/pause buttons when audio ends
    $d706c914d748cb55$var$audioElement.addEventListener('ended', ()=>{
        $d706c914d748cb55$var$playing = false;
        $d706c914d748cb55$var$audioElement.currentTime = 0;
        $d706c914d748cb55$var$playIcon.classList.remove('hidden');
        $d706c914d748cb55$var$pauseIcon.classList.add('hidden');
        $d706c914d748cb55$var$updateProgress();
    });
    // Reset play/pause buttons when audio ends
    $d706c914d748cb55$var$audioElement.addEventListener('stalled', ()=>{
        // TODO: Handle audio stalling ?
        console.error('Audio stalled');
    });
    // Handle language change
    window.addEventListener('languagechange', ()=>{
        if ($d706c914d748cb55$var$currentPoint) $d706c914d748cb55$var$playPoint($d706c914d748cb55$var$currentPoint, true);
    });
    // Get the map element and clear it
    const mapElement = document.getElementById('points');
    mapElement.innerHTML = '';
    // Place points on the map
    (0, $b11092b003750ebb$export$9f048bf86ee2e9d2).forEach((point)=>{
        const pointElement = document.createElement('button');
        // NOTE: Any Tailwind class modification here should be reflected in the
        // placeholder code in index.html
        pointElement.className = `listening-point absolute flex size-[10vw] group open:z-10`;
        pointElement.style = `left: ${point.pos[0]}%; top: ${point.pos[1]}%`;
        pointElement.innerHTML = `
      <span class="pointer-events-none absolute left-0 top-0 inline-flex h-full w-full rounded-full bg-[rgb(194,166,98)] group-open:motion-safe:animate-ping"></span>
      <span class="relative inline-flex size-[10vw] items-center justify-center rounded-full border-[1vw] border-[rgb(194,166,98)] bg-white text-center text-[5vw] font-semibold shadow shadow-black/30 group-open:scale-125 group-open:border-[rgb(194,166,98)] group-open:bg-black group-open:text-white">${point.number}
    `;
        pointElement.setAttribute('aria-label', `Point d'\xe9coute ${point.number}`);
        pointElement.setAttribute('data-point', point.number);
        mapElement.appendChild(pointElement);
        // Add event listeners for point buttons
        pointElement.addEventListener('click', async (event)=>{
            event.preventDefault();
            $d706c914d748cb55$var$playPoint(point);
        });
    });
}
function $d706c914d748cb55$var$playPoint(point, force = false) {
    const pointElement = document.querySelector(`[data-point="${point.number}"]`);
    const titleElement = document.querySelector('#title');
    const transcriptionPanel = document.getElementById('transcription-panel');
    $d706c914d748cb55$var$currentPoint = point;
    if ($d706c914d748cb55$var$playing) {
        // Stop the audio if it's playing
        $d706c914d748cb55$var$audioElement.pause();
        $d706c914d748cb55$var$audioElement.currentTime = 0;
        $d706c914d748cb55$var$currentPoint = null;
    }
    // Close the player if it's already open
    if (pointElement.hasAttribute('open') && !force) {
        (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)(pointElement);
        $d706c914d748cb55$var$player.classList.add('hidden');
    } else {
        // Close all other points
        const elements = document.querySelectorAll('.listening-point');
        elements.forEach((el)=>{
            if (el !== pointElement) (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)(el);
        });
        // Open the clicked point
        (0, $fe8af8a42c4a74bc$export$f10f97528f780cc6)(pointElement);
        // Close transcription panel if open
        (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)(transcriptionPanel);
        // Show loading animation
        $d706c914d748cb55$var$playControls.classList.add('hidden');
        $d706c914d748cb55$var$loading.classList.remove('hidden');
        // Set the title to "Loading..."
        titleElement.innerHTML = $ad8ee3d37bdec1f0$export$4e490aaac5c28cc3('audioguide-player-loading-text');
        // Fetch transcription title and text
        const transcriptionText = fetch(`./text/${$ad8ee3d37bdec1f0$export$dec8f99c0c14e178()}${point.number.toString().padStart(2, '0')}.txt`).then((response)=>response.text()).then((text)=>{
            // Get elements
            const transcriptionElement = document.querySelector('#transcription-content');
            // Split title and transcription
            const lines = text.split('\n');
            const title = lines[0];
            let transcription = lines.slice(2).join('\n\n').trim();
            // Detect missing transcription
            if (transcription.length === 0) transcription = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
            // Insert title and transcription into player
            titleElement.innerHTML = title;
            transcriptionElement.innerHTML = transcription;
            transcriptionElement.scrollTop = 0;
            // show player
            $d706c914d748cb55$var$player.classList.remove('hidden');
        }).catch((error)=>{
            console.error('Error:', error);
            alert("Le chargement du point d'\xe9coute a \xe9chou\xe9. Veuillez r\xe9essayer.");
            (0, $fe8af8a42c4a74bc$export$ff74030248f7f2bd)(pointElement);
        });
        // Replace the audio source
        $d706c914d748cb55$var$audioElement.src = `./audio/${$ad8ee3d37bdec1f0$export$dec8f99c0c14e178()}${point.number.toString().padStart(2, '0')}.mp3`;
        $d706c914d748cb55$var$audioElement.addEventListener('canplay', (event)=>{
            $d706c914d748cb55$var$playControls.classList.remove('hidden');
            $d706c914d748cb55$var$loading.classList.add('hidden');
        // Audio should autoplay from <audio autoplay="true">
        // The play controls are shown to the user otherwise
        });
    }
}
function $d706c914d748cb55$var$updateProgress() {
    const progress = $d706c914d748cb55$var$audioElement.currentTime / $d706c914d748cb55$var$audioElement.duration;
    $25be8ad6e28b139f$export$e352b740a6841494(progress);
    const progressText = document.getElementById('time');
    const timeLeft = $d706c914d748cb55$var$audioElement.duration - $d706c914d748cb55$var$audioElement.currentTime;
    const minutes = Math.floor(timeLeft / 60);
    const seconds = Math.floor(timeLeft % 60);
    progressText.innerHTML = `${minutes.toString()}:${seconds.toString().padStart(2, '0')}`;
}
$d706c914d748cb55$var$init();
$25be8ad6e28b139f$export$2cd8252107eb640b('progress-indicator');


//# sourceMappingURL=audioguide-cathedrale-lausanne.d9ae75ed.js.map
